export default {"src":"/_next/static/media/instagram-round_svgrepo.com.3cbab27a.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};